(function () {
    'use strict';

    angular
        .module('appback')
        .controller('ContactoController', ContactoController)

    ContactoController.$inject = ["ContactService"];

    function ContactoController(ContactService) {
        var cc = this;

        var url = new URL(window.location.href);

        cc.contact = null;
        cc.masDatos = [];
        cc.loading = true;
        cc.notFound = false;
        cc.contactId = url.searchParams.get('id');
        cc.type = url.searchParams.get('type') || 'contacto';

        // Pestañas de la ficha: las de uranoexports.tech (Información y
        // Actividad), las conversaciones y los tipos de contenido reales de la
        // CRM que se relacionan con un contacto.
        cc.viewOptions = [
            { id: 'informacion', name: 'Información', icon: 'person', description: 'Datos del contacto, distribuidor, notas internas y productos de interés.' },
            // { id: 'actividad', name: 'Actividad', icon: 'history', description: 'Notas y cambios de estado de este contacto.' },
            { id: 'conversaciones', name: 'Conversaciones', icon: 'mail', description: 'Conversaciones por email, WhatsApp y otros canales conectados.' },
            { id: 'oportunidad', name: 'Oportunidades', icon: 'monetization_on', description: 'Negociaciones comerciales abiertas o cerradas con este contacto.', columns: [
                { field: 'titulo', label: 'Título' },
                { field: 'estado', label: 'Estado' },
                { field: 'importe_estimado', label: 'Importe estimado' },
                { field: 'fecha_cierre_prevista', label: 'Cierre previsto' }
            ]},
            // { id: 'pedido', name: 'Pedidos', icon: 'shopping_cart', description: 'Pedidos de compra registrados para este contacto.', columns: [
            //     { field: 'numero', label: 'Número' },
            //     { field: 'fecha_pedido', label: 'Fecha' },
            //     { field: 'estado', label: 'Estado' },
            //     { field: 'importe', label: 'Importe' }
            // ]},
            // // { id: 'venta', name: 'Ventas', icon: 'point_of_sale', description: 'Ventas y facturación asociadas a este contacto.', columns: [
            //     { field: 'numero', label: 'Número' },
            //     { field: 'fecha_venta', label: 'Fecha' },
            //     { field: 'estado', label: 'Estado' },
            //     { field: 'importe_total', label: 'Importe' }
            // ]},
            // { id: 'incidencia', name: 'Incidencias', icon: 'report_problem', description: 'Incidencias o tickets de soporte abiertos por este contacto.', columns: [
            //     { field: 'codigo', label: 'Código' },
            //     { field: 'titulo', label: 'Título' },
            //     { field: 'prioridad', label: 'Prioridad' },
            //     { field: 'estado', label: 'Estado' }
            // ]},
            // { id: 'documento', name: 'Documentos', icon: 'description', description: 'Ficheros y documentación adjunta a este contacto.', columns: [
            //     { field: 'titulo', label: 'Título' },
            //     { field: 'categoria', label: 'Categoría' },
            //     { field: 'fecha_documento', label: 'Fecha' },
            //     { field: 'estado', label: 'Estado' }
            // ]}
        ];

        cc.selectedOption = cc.viewOptions[0];
        cc.related = {};

        // Estados, distribuidores, productos de interés, origen y actividad (ContactoController::actionGetficha()).
        cc.ficha = { loading: false, error: false, data: null, guardando: false };
        cc.nota = '';

        cc.conversaciones = { loading: false, error: false, data: [] };
        cc.hilo = { loading: false, error: false, mensajes: [], canal: null };
        cc.replyText = '';
        cc.replyNote = '';
        cc.replySending = false;
        cc.nuevaConversacion = { loading: false, error: false, canales: [], selected: null, titulo: '', texto: '', enviando: false };

        cc.getcontact = function () {
            cc.loading = true;

            ContactService.GetContact(cc.contactId).then(function (response) {
                cc.contact = response;
                prepararContacto(cc.contact);
                cc.cargarFicha();
            }, function () {
                cc.contact = null;
                cc.notFound = true;
            }).finally(function () {
                cc.loading = false;
            });
        };

        cc.formatFecha = function (fecha) {
            if (!fecha) {
                return '';
            }

            // MySQL manda "Y-m-d H:i:s" (espacio, no "T"): algunos navegadores
            // (Safari) no lo parsean como fecha válida si no se normaliza a ISO 8601.
            var date = new Date(String(fecha).replace(' ', 'T'));
            if (isNaN(date.getTime())) {
                return fecha;
            }

            return date.toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
        };

        // Texto de un campo del contacto o de un registro relacionado, o ''
        // si no tiene: los campos vacíos llegan como null (o false), y las
        // relaciones (pais_id, distribuidor_id...) como objeto o lista.
        cc.texto = function (valor) {
            if (valor === null || valor === undefined || valor === false) {
                return '';
            }
            if (angular.isArray(valor)) {
                return valor.map(cc.texto).filter(Boolean).join(', ');
            }
            if (angular.isObject(valor)) {
                return cc.texto(valor.nombre || valor.titulo || valor.name || '');
            }

            var texto = String(valor).trim();
            return texto === 'null' ? '' : texto;
        };

        // Lo que se pinta en una celda: el texto o una raya si está vacío.
        cc.valor = function (valor) {
            return cc.texto(valor) || '—';
        };

        // Solo la fecha (los campos de fecha del contacto no llevan hora).
        cc.formatDia = function (fecha) {
            var texto = cc.texto(fecha);
            if (!texto || texto.indexOf('0000-00-00') === 0) {
                return '';
            }

            var date = new Date(texto.replace(' ', 'T'));
            if (isNaN(date.getTime())) {
                return texto;
            }

            return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
        };

        cc.changeView = function (option) {
            cc.selectedOption = option;

            if (option.id === 'conversaciones') {
                cc.loadConversaciones();
            } else if (option.columns) {
                cc.loadRelated(option);
            }
        };

        cc.cargarFicha = function () {
            cc.ficha.loading = true;
            cc.ficha.error = false;

            ContactService.GetFicha(cc.contactId).then(function (data) {
                cc.ficha.data = data;
            }, function () {
                cc.ficha.error = 'No se ha podido cargar la ficha.';
            }).finally(function () {
                cc.ficha.loading = false;
            });
        };

        // Las tres devuelven la ficha ya actualizada (con la actividad nueva).
        function guardarFicha(peticion) {
            cc.ficha.guardando = true;
            cc.ficha.error = false;

            return peticion.then(function (data) {
                cc.ficha.data = data;
            }, function (response) {
                cc.ficha.error = (response && response.data && response.data.msg) || 'No se ha podido guardar el cambio.';
            }).finally(function () {
                cc.ficha.guardando = false;
            });
        }

        cc.cambiarEstado = function (estado) {
            if (cc.ficha.guardando || !cc.ficha.data || cc.ficha.data.estadoId === estado.id) {
                return;
            }
            guardarFicha(ContactService.CambiarEstado(cc.contactId, estado.id));
        };

        cc.asignarDistribuidor = function () {
            guardarFicha(ContactService.AsignarDistribuidor(cc.contactId, cc.ficha.data.distribuidorId));
        };

        cc.anadirNota = function () {
            var nota = (cc.nota || '').trim();
            if (!nota || cc.ficha.guardando) {
                return;
            }
            guardarFicha(ContactService.Nota(cc.contactId, nota)).then(function () {
                if (!cc.ficha.error) {
                    cc.nota = '';
                }
            });
        };

        cc.estadoActual = function () {
            var estados = cc.ficha.data ? cc.ficha.data.estados : [];
            return estados.filter(function (estado) { return estado.id === cc.ficha.data.estadoId; })[0] || null;
        };

        cc.loadRelated = function (option) {
            if (cc.related[option.id]) {
                return;
            }

            cc.related[option.id] = { loading: true, data: [], error: false };

            ContactService.GetRelacionados(cc.contactId, option.id).then(function (data) {
                cc.related[option.id].data = data;
            }, function () {
                cc.related[option.id].error = true;
            }).finally(function () {
                cc.related[option.id].loading = false;
            });
        };

        // Deja en el contacto los textos ya listos para la vista (sin null)
        // y los datos extra de la pestaña Información (cc.masDatos).
        function prepararContacto(contacto) {
            var texto = cc.texto;
            var telefono = texto(contacto.telefono);
            var prefijo = contacto.pais_id ? texto(contacto.pais_id.codigo_telefono) : '';
            var email = texto(contacto.email);
            var web = texto(contacto.web);
            var linkedin = texto(contacto.linkedin);

            contacto.nombreCompleto = [texto(contacto.nombre), texto(contacto.apellidos)].filter(Boolean).join(' ');
            contacto.iniciales = contacto.nombreCompleto
                ? contacto.nombreCompleto.split(/\s+/).slice(0, 2).map(function (parte) { return parte.charAt(0); }).join('').toUpperCase()
                : '';
            contacto.cabecera = [texto(contacto.cargo), texto(contacto.empresa)].filter(Boolean).join(' · ');
            contacto.telefonoCompleto = telefono && prefijo && telefono.charAt(0) !== '+' ? prefijo + ' ' + telefono : telefono;
            contacto.address = [
                texto(contacto.direccion),
                [texto(contacto.cp), texto(contacto.poblacion)].filter(Boolean).join(' '),
                texto(contacto.provincia)
            ].filter(Boolean).join(', ');
            contacto.webUrl = enlace(web);
            contacto.linkedinUrl = linkedin && !/[\/.]/.test(linkedin) ? 'https://www.linkedin.com/in/' + linkedin : enlace(linkedin);
            contacto.comentariosTexto = textoPlano(contacto.comentarios);
            contacto.sinDatos = !contacto.nombreCompleto && !email && !telefono && !texto(contacto.empresa);
            contacto.creadoTexto = cc.formatDia(contacto.created);
            contacto.actualizadoTexto = cc.formatDia(contacto.updated);

            // Lo que la pestaña Información no enseña ya en su cabecera, solo si tiene valor.
            cc.masDatos = [
                { label: 'Teléfono', icon: 'phone', valor: contacto.telefonoCompleto, href: telefono ? 'tel:' + contacto.telefonoCompleto.replace(/[^\d+]/g, '') : '' },
                { label: 'Web', icon: 'language', valor: web, href: contacto.webUrl, externo: true },
                { label: 'LinkedIn', icon: 'work', valor: linkedin, href: contacto.linkedinUrl, externo: true },
                { label: 'Dirección', icon: 'home_pin', valor: contacto.address },
                { label: 'Departamento', icon: 'groups', valor: texto(contacto.departamento) },
                { label: 'Idioma', icon: 'translate', valor: texto(contacto.idioma) },
                { label: 'Responsable comercial', icon: 'support_agent', valor: texto(contacto.responsable_id) },
                { label: 'Newsletter', icon: 'campaign', valor: contacto.newsletter === null || contacto.newsletter === undefined ? '' : (parseInt(contacto.newsletter, 10) ? 'Suscrito' : 'No suscrito') },
                { label: 'Último contacto', icon: 'history', valor: cc.formatDia(contacto.ultimo_contacto) },
                { label: 'Próximo seguimiento', icon: 'event', valor: cc.formatDia(contacto.proximo_contacto) }
            ].filter(function (campo) { return campo.valor; });
        }

        // URL con protocolo: en las tarjetas la web suele venir como "www.empresa.com".
        function enlace(url) {
            if (!url) {
                return '';
            }
            return /^https?:\/\//i.test(url) ? url : 'https://' + url;
        }

        // Comentarios es un campo de editor (HTML): se muestra solo su texto.
        function textoPlano(html) {
            var texto = cc.texto(html);
            if (!texto) {
                return '';
            }
            var div = document.createElement('div');
            div.innerHTML = texto.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n');
            return (div.textContent || '').trim();
        }

        cc.editContact = function () {
            if (!cc.contact) {
                return;
            }

            window.location.href = 'update?id=' + cc.contact.id + '&type=contacto';
        };

        // -- Conversaciones (Mensajes): lista de canales con historial, hilo por
        // canal con respuesta, y arranque de conversación nueva por un canal
        // conectado. Misma lógica de envío real (WAHA/RustMailer) que el
        // dashboard, pero en el ContactoController y acotada a este contacto.

        cc.loadConversaciones = function () {
            cc.conversaciones = { loading: true, error: false, data: [] };

            ContactService.GetConversaciones(cc.contactId).then(function (data) {
                cc.conversaciones.data = data;
            }, function () {
                cc.conversaciones.error = 'No se han podido cargar las conversaciones.';
            }).finally(function () {
                cc.conversaciones.loading = false;
            });
        };

        cc.abrirConversacion = function (conversacion) {
            cc.hilo = { loading: true, error: false, mensajes: [], canal: conversacion };
            cc.replyText = '';
            cc.replyNote = '';

            ContactService.GetMensajes(cc.contactId, conversacion.id).then(function (data) {
                cc.hilo.mensajes = data;
            }, function () {
                cc.hilo.error = 'No se ha podido cargar la conversación.';
            }).finally(function () {
                cc.hilo.loading = false;
            });
        };

        cc.discardReply = function () {
            cc.replyText = '';
            cc.replyNote = '';
        };

        // Envuelve el texto seleccionado del textarea de respuesta con el
        // marcador dado. WhatsApp interpreta *texto* como negrita y _texto_
        // como cursiva, así que estos botones producen formato real, no solo
        // cosmético, en ese canal (en el resto simplemente se envían los
        // asteriscos/guiones bajos como texto plano).
        cc.formatReply = function (marker) {
            var textarea = document.getElementById('contactoReplyText');
            if (!textarea) {
                return;
            }

            var start = textarea.selectionStart || 0;
            var end = textarea.selectionEnd || 0;
            var text = cc.replyText || '';
            var selected = text.slice(start, end) || 'texto';

            cc.replyText = text.slice(0, start) + marker + selected + marker + text.slice(end);

            setTimeout(function () {
                textarea.focus();
                textarea.setSelectionRange(start + marker.length, start + marker.length + selected.length);
            });
        };

        cc.enviarRespuesta = function () {
            var texto = (cc.replyText || '').trim();
            var ultimo = cc.hilo.mensajes.length ? cc.hilo.mensajes[cc.hilo.mensajes.length - 1] : null;

            if (!texto || !ultimo) {
                return;
            }

            cc.replySending = true;

            ContactService.Responder(ultimo.id, texto, cc.replyNote).then(function (respuesta) {
                cc.hilo.mensajes.push(respuesta);
                cc.replyText = '';
                cc.replyNote = '';
                cc.loadConversaciones();
            }, function (response) {
                cc.hilo.error = (response && response.msg) || 'No se ha podido enviar la respuesta.';
            }).finally(function () {
                cc.replySending = false;
            });
        };

        cc.abrirNuevaConversacion = function () {
            cc.nuevaConversacion = { loading: true, error: false, canales: [], selected: null, titulo: '', texto: '', enviando: false };
            getNewConversationModal().show();

            ContactService.CanalesDisponibles(cc.contactId).then(function (data) {
                cc.nuevaConversacion.canales = data;
            }, function () {
                cc.nuevaConversacion.error = 'No se han podido cargar tus canales conectados.';
            }).finally(function () {
                cc.nuevaConversacion.loading = false;
            });
        };

        cc.seleccionarCanal = function (canal) {
            if (!canal.puedeEnviar) {
                return;
            }

            cc.nuevaConversacion.selected = canal;
        };

        cc.enviarNuevaConversacion = function () {
            var texto = (cc.nuevaConversacion.texto || '').trim();
            var titulo = (cc.nuevaConversacion.titulo || '').trim();
            var canal = cc.nuevaConversacion.selected;

            if (!texto || !titulo || !canal) {
                return;
            }

            cc.nuevaConversacion.enviando = true;

            ContactService.IniciarConversacion(cc.contactId, canal.id, texto, titulo).then(function () {
                getNewConversationModal().hide();
                cc.loadConversaciones();
            }, function (response) {
                cc.nuevaConversacion.error = (response && response.msg) || 'No se ha podido enviar el mensaje.';
            }).finally(function () {
                cc.nuevaConversacion.enviando = false;
            });
        };

        var newConversationModal = null;

        function getNewConversationModal() {
            if (!newConversationModal) {
                newConversationModal = new bootstrap.Modal(document.getElementById('newConversationModal'));
            }

            return newConversationModal;
        }
    }
})();